import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import ReactPhoneInput from "react-phone-input-2";

// GraphQL
import InviteUserMutation from "../../GraphQL/Mutations/InviteUser";
import GetCompanyUsers from "../../GraphQL/Queries/GetCompanyUsers";

// Presentation/UI
import Loader from "../../Components/Loader";
import FormCheckbox from "../../Components/FormElements/FormCheckbox";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  closeModal(): void;
  notification(message: string): void;
}

class AddUserForm extends React.Component<IProps> {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    isATechnician: false,
    loading: false,
    error: null
  };

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "firstName":
        this.setState({ firstName: value });
        break;
      case "lastName":
        this.setState({ lastName: value });
        break;
      case "email":
        this.setState({ email: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    const { firstName, lastName, email, phoneNumber } = this.state;
    // Check for undefined or empty infput fields
    if (!firstName || !lastName || !email || !phoneNumber) {
      this.setError("Please fill in the fields");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  isATechnician = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ isATechnician: !this.state.isATechnician });
  };

  render() {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      isATechnician
    } = this.state;
    const { companyId, closeModal, notification } = this.props;
    return (
      <Mutation<{}, {}> mutation={InviteUserMutation}>
        {(inviteUser, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                inviteUser({
                  variables: {
                    firstName,
                    lastName,
                    email,
                    phoneNumber,
                    invite: true,
                    isATechnician,
                    companyId
                  },
                  refetchQueries: [
                    {
                      query: GetCompanyUsers,
                      variables: { id: companyId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("User has been invited");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="firstName">First Name</Label>
              <Input
                type="text"
                name="firstName"
                id="firstName"
                placeholder="First name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="lastName">Last Name</Label>
              <Input
                type="text"
                name="lastName"
                id="lastName"
                placeholder="Last name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email Address</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="Email"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Phone Number</Label>
              <ReactPhoneInput
                value={phoneNumber}
                defaultCountry={"za"}
                onChange={(userPhoneNumber: any) =>
                  this.setState({ phoneNumber: userPhoneNumber })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label>Is the user a technician?</Label>
              <FormCheckbox
                name="isATechnician"
                checked={isATechnician}
                label={!isATechnician ? "No" : "Yes"}
                htmlFor={`isATechnician`}
                inlineStyling={{
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  paddingTop: "5px",
                  paddingBottom: "5px"
                }}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  this.isATechnician(e)
                }
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Invite User</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default AddUserForm;



// WEBPACK FOOTER //
// ./src/Containers/Users/AddUserForm.tsx